module.exports = __webpack_public_path__ + "img/goldregen-2020-104.3ae49e16.jpg";